var path = 'src/app/cohorts/cohort-detail.html';
var html = "<div page-wrapper> <h1 class=page-header>{{cohort.name}} <small>{{cohort.code}}</small></h1> <div patients-by-recruitment-date-graph group=cohort></div> <div class=row> <div class=col-md-6> <h2>Hospitals</h2> <div patients-by-group-table group=cohort group-type=HOSPITAL></div> </div> <div class=col-md-6> <h2>Recruiting Hospitals</h2> <div patients-by-recruitment-group-table group=cohort></div> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/cohorts/cohort-detail.html
// module id = 70
// module chunks = 0